var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21564 10.634C10.5392 10.634 11.6851 10.1593 12.6217 9.22276C13.558 8.28634 14.0328 7.14056 14.0328 5.81687C14.0328 4.49363 13.5581 3.3477 12.6216 2.41097C11.685 1.4747 10.539 1 9.21564 1C7.89194 1 6.74615 1.4747 5.80972 2.41113C4.87329 3.34755 4.39844 4.49348 4.39844 5.81687C4.39844 7.14056 4.87329 8.28649 5.80972 9.22292C6.74646 10.1592 7.8924 10.634 9.21564 10.634ZM6.63858 3.23983C7.35712 2.52129 8.20001 2.17202 9.21564 2.17202C10.2311 2.17202 11.0742 2.52129 11.7928 3.23983C12.5114 3.95851 12.8608 4.80155 12.8608 5.81687C12.8608 6.83249 12.5114 7.67538 11.7928 8.39406C11.0742 9.11275 10.2311 9.46202 9.21564 9.46202C8.20032 9.46202 7.35742 9.1126 6.63858 8.39406C5.91989 7.67553 5.57047 6.83249 5.57047 5.81687C5.57047 4.80155 5.91989 3.95851 6.63858 3.23983Z",
    fill: "url(#paint0_linear_6573_1859)",
    stroke: "url(#paint1_linear_6573_1859)",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6457 16.3788C17.6187 15.9891 17.564 15.564 17.4836 15.1151C17.4024 14.6629 17.2979 14.2353 17.1728 13.8445C17.0434 13.4406 16.8678 13.0418 16.6503 12.6595C16.425 12.2628 16.1601 11.9174 15.8628 11.6331C15.552 11.3357 15.1714 11.0966 14.7314 10.9222C14.2928 10.7487 13.8069 10.6608 13.287 10.6608C13.0828 10.6608 12.8854 10.7446 12.5041 10.9928C12.2694 11.1459 11.9949 11.3229 11.6885 11.5186C11.4265 11.6856 11.0716 11.842 10.6332 11.9836C10.2055 12.122 9.77121 12.1922 9.34244 12.1922C8.91397 12.1922 8.47971 12.122 8.0517 11.9836C7.61377 11.8421 7.2587 11.6857 6.99716 11.5188C6.69366 11.3249 6.41901 11.1479 6.18082 10.9927C5.7998 10.7444 5.60236 10.6606 5.39819 10.6606C4.87817 10.6606 4.39233 10.7487 3.95395 10.9223C3.51419 11.0964 3.13348 11.3355 2.82236 11.6332C2.52512 11.9177 2.26022 12.263 2.035 12.6595C1.81787 13.0418 1.64209 13.4405 1.5127 13.8447C1.38773 14.2355 1.2832 14.6629 1.20203 15.1151C1.12146 15.5634 1.06699 15.9887 1.03998 16.3793C1.01343 16.7612 1 17.1587 1 17.5603C1 18.6043 1.33188 19.4495 1.98633 20.0728C2.63269 20.6879 3.48779 20.9998 4.52798 20.9998H14.1581C15.198 20.9998 16.0531 20.6879 16.6996 20.0728C17.3542 19.45 17.6861 18.6045 17.6861 17.5602C17.6859 17.1572 17.6724 16.7597 17.6457 16.3788ZM15.8915 19.2237C15.4644 19.6302 14.8974 19.8278 14.158 19.8278H4.52798C3.78839 19.8278 3.22137 19.6302 2.79443 19.2238C2.37558 18.8251 2.17203 18.2808 2.17203 17.5603C2.17203 17.1856 2.18439 16.8155 2.20911 16.4603C2.23322 16.1118 2.2825 15.729 2.35559 15.3222C2.42776 14.9204 2.51962 14.5434 2.62888 14.202C2.7337 13.8747 2.87668 13.5506 3.05399 13.2385C3.22321 12.9409 3.41791 12.6856 3.63275 12.4799C3.83371 12.2875 4.08701 12.1301 4.38547 12.012C4.6615 11.9027 4.97171 11.8429 5.30847 11.8339C5.34952 11.8557 5.42261 11.8974 5.54102 11.9746C5.78195 12.1316 6.05966 12.3107 6.36667 12.5068C6.71274 12.7274 7.1586 12.9267 7.69128 13.0987C8.23587 13.2748 8.79129 13.3642 9.34259 13.3642C9.89389 13.3642 10.4495 13.2748 10.9937 13.0988C11.5269 12.9266 11.9726 12.7274 12.3191 12.5065C12.6333 12.3057 12.9032 12.1317 13.1442 11.9746C13.2626 11.8975 13.3357 11.8557 13.3767 11.8339C13.7136 11.8429 14.0238 11.9027 14.3 12.012C14.5983 12.1301 14.8516 12.2877 15.0526 12.4799C15.2674 12.6855 15.4621 12.9408 15.6313 13.2386C15.8088 13.5506 15.9519 13.8749 16.0566 14.2019C16.166 14.5437 16.258 14.9206 16.33 15.322C16.403 15.7296 16.4524 16.1126 16.4765 16.4605V16.4608C16.5014 16.8146 16.5139 17.1845 16.5141 17.5603C16.5139 18.281 16.3104 18.8251 15.8915 19.2237Z",
    fill: "url(#paint2_linear_6573_1859)",
    stroke: "url(#paint3_linear_6573_1859)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6573_1859",
    x1: 6.78905,
    y1: 1.57823,
    x2: 11.5483,
    y2: 9.82188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6573_1859",
    x1: 6.78905,
    y1: 1.57823,
    x2: 11.5483,
    y2: 9.82188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6573_1859",
    x1: 5.14037,
    y1: 11.2812,
    x2: 8.88143,
    y2: 21.7386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6573_1859",
    x1: 5.14037,
    y1: 11.2812,
    x2: 8.88143,
    y2: 21.7386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccount);
export default __webpack_public_path__ + "static/media/MyAccount.e2de51e9b6cc613d29a267e155e091a9.svg";
export { ForwardRef as ReactComponent };